<template>
  <div class="mobile-brand-box">
    <div class="mobile-content">
      <div class="mobile-top">
        <div class="mobile-en-title">BRAND</div>
        <div class="mobile-cn-title">品牌设计</div>
      </div>
      <div class="mobile-bottom" v-html="cleanHtmlText(data.content)"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
